import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { deleteUser } from '../../controllers/userManagementController';

const DeleteUserDialog = ({ open, onClose, user, onDeleted }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    if (!user) return;
    setError('');
    setLoading(true);
    try {
      await deleteUser(user.id);
      onDeleted?.();
      onClose?.();
    } catch (e) {
      setError(e?.message || 'Kullanıcı silinemedi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontSize: '18px',
          fontWeight: 500,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 3,
        }}
      >
        Kullanıcıyı Sil
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ py: 2, px: 3 }}>
        <Box>
          {error && (
            <Typography variant="body2" color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Typography variant="body2" sx={{ fontSize: '14px' }}>
            {user ? `${user.username} kullanıcısını silmek istediğinize emin misiniz?` : 'Bu kullanıcıyı silmek istediğinize emin misiniz?'}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ py: 2, px: 3 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            textTransform: 'none',
            color: '#0E4D94',
          }}
        >
          İptal
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: '5px',
            textTransform: 'none',
            fontSize: '14px',
            boxShadow: 'none',
            backgroundColor: '#F8285A',
            '&:hover': {
              backgroundColor: '#E01E4A',
              boxShadow: 'none',
            },
          }}
        >
          Sil
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserDialog;
